var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueConfetti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BlueConfetti") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BlueConfetti",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5582939,3.79017798 L3.7082939,16.933178 C2.8282939,17.765178 1.4282939,17.727178 0.598293898,16.850178 C-0.231706102,15.974178 -0.191706102,14.575178 0.678293898,13.743178 L14.5282939,0.600177984 C15.4082939,-0.231822016 16.8082939,-0.193822016 17.6382939,0.683177984 C18.4682939,1.55917798 18.4382939,2.95817798 17.5582939,3.79017798",
    id: "Fill-103",
    fill: "#494C84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueConfetti);
export default __webpack_public_path__ + "static/media/BlueConfetti.15863b80cd092d0c9acc0e2e4fcbab6e.svg";
export { ForwardRef as ReactComponent };